import {Component, OnInit} from '@angular/core';
import {MessageService} from "primeng/api";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {QuestionService} from "../question.service";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {FormTypes} from '../../forms/models/constants';
import {FormElementComponent} from '../../forms/form-element/form-element.component';
import {CommonModule} from '@angular/common';
import {PropertyService} from '../../forms/services/property.service';

@Component({
    selector: 'app-question-content',
    templateUrl: './question-content.component.html',
    styleUrls: ['./question-content.component.scss'],
    providers: [MessageService, PropertyService],
    imports: [
        FormElementComponent, CommonModule
    ],
    standalone: true
})
export class QuestionContentComponent implements OnInit {

    protected readonly FormTypes = FormTypes;
    isAdmin: boolean = true;
    schoButton: boolean = true;

    formGroup: FormGroup;

    key!: string;

    constructor(private formBuilder: FormBuilder,
                public ref: DynamicDialogRef,
                public config: DynamicDialogConfig,
                private questionService: QuestionService) {

        this.formGroup = this.formBuilder.group({
            text: new FormControl(''),
        })
    }

    async ngOnInit(): Promise<void> {
        this.key = this.config.data['key'];
        this.isAdmin = this.config.data['isAdmin'];

        const text = await this.questionService.getContent(this.key);
        this.formGroup.controls['text'].setValue(text);

    }

    async saveContent() {

        this.schoButton = false;
        const text = await this.questionService.getContent(this.key);

        this.questionService.putContent(this.key, this.formGroup.controls['text'].value)
    }

}
